import { describeMinutes, formatMinutesAsHoursAndMinutes } from '~/utils/date/duration';
import { ICeMonthlyRecord } from '~/services/api/communityEngagement/types';
import { formatDollars } from '~/ui/pages/Clients/reusable/CommunityEngagement/helpers/formatAmount';

type ITotals = Pick<
  ICeMonthlyRecord,
  | 'totalMinutesWorked'
  | 'totalCurrencyEarned'
  | 'monthlyMinutesThreshold'
  | 'monthlyCurrencyThreshold'
>;

export const formatCeChip = ({
  totalMinutesWorked,
  totalCurrencyEarned,
  monthlyMinutesThreshold,
  monthlyCurrencyThreshold,
}: ITotals): string => {
  const hoursThreshold =
    monthlyMinutesThreshold === null
      ? ''
      : ` / ${formatMinutesAsHoursAndMinutes(monthlyMinutesThreshold)}`;
  const hours = `CE ${formatMinutesAsHoursAndMinutes(totalMinutesWorked)}${hoursThreshold}`;
  if (monthlyCurrencyThreshold === null) return hours;
  return `${hours} | ${formatDollars(totalCurrencyEarned)} / ${formatDollars(
    monthlyCurrencyThreshold,
  )}`;
};

export const describeCeChip = ({
  totalMinutesWorked,
  totalCurrencyEarned,
  monthlyMinutesThreshold,
  monthlyCurrencyThreshold,
}: ITotals): string => {
  const hours =
    monthlyMinutesThreshold === null
      ? describeMinutes(totalMinutesWorked)
      : `${describeMinutes(totalMinutesWorked)} of ${describeMinutes(monthlyMinutesThreshold)}`;
  const dollars =
    monthlyCurrencyThreshold === null
      ? ''
      : `, ${formatDollars(totalCurrencyEarned)} of ${formatDollars(monthlyCurrencyThreshold)}`;
  return `Community engagement: ${hours}${dollars}`;
};
